import React from 'react';
import { useContext } from 'react';
import { Context } from '../context/AppContext';
import { Container, Heading, Text } from './About/AboutStyles';

const About = () => {
  const { locale } = useContext(Context);
  return locale === 'ru' ? (
    <Container>
      <Heading>Юлия Фиалковская</Heading>
      <Text>
        Мои работы — это знаки присутствия в непрерывном художественном
        процессе.
      </Text>
      <Text>
        Простые вещи и события становятся импульсами для рисунка. Эти импульсы
        приходят извне, затем совершается реакция, которая ложится на холст или
        бумагу. Само по себе произведение является конечным продуктом, а не
        основной целью, которая заключается в процессе реагирования.
      </Text>
      <Text>
        Мой внутренний мотив не является ведущим, не существует некой внутренней
        программы, которая определяет мой стиль или художественный метод. Тем не
        менее это не значит, что эти вещи отсутствуют, напротив — они намеренно
        не осознаются.
      </Text>
      <Text>
        Частью меня является осознанная стихийность. В процессе работы это
        превратилось в художественный прием, который позволяет мне браться за
        любую тему и технику в изображении, ведь для демонстрации своего
        представления о чем-либо необязательно выступать специалистом.
      </Text>
      <Text>
        Мое искусство – это искусство спокойных внутренних реакций и трезвого,
        прагматичного ума.
      </Text>
    </Container>
  ) : (
    <Container>
      <Heading>Julia Fialkovskaia</Heading>
      <Text>
        My works are signs of presence in a continious artistic process.
      </Text>
      <Text>
        Simple things and events become impulses for drawing. These impulses
        come from outside, then a reaction takes place, which falls on canvas or
        paper. The work itself is the end product but not the main goal.
      </Text>
      <Text>
        The internal motive is not the leading one, there is no internal program
        that determines the style or artistic method. Nevertheless, this does
        not mean that these things are absent, on the contrary, they are
        intentionally not realized.
      </Text>
      <Text>
        Conscious spontaniety is an important part of my method. In the process
        of work, this turned into an artistic technique that allows to take on
        any topic and technique, because it is not necessary to act as a
        specialist to demonstrate the idea of something.
      </Text>
      <Text>
        My art is calm inner reactions committed by a sober, pragmatic mind.
      </Text>
    </Container>
  );
};

export default About;
